import React from "react";

import { GridItem, GridRow } from "commons/ui/Grid";
import Select from "commons/ui/input/Select";

import FiltersContainer from "components/ui/FiltersContainer";
import SearchInput from "components/ui/SearchInput";

import { WorkOffersListHook } from "hooks/list/useWorkOffersList";

function WorkOffersExtraFilters({
    workOffersListHook,
}: {
    workOffersListHook: WorkOffersListHook;
}) {
    const { staticFilterHook } = workOffersListHook;

    const { setValue, form } = staticFilterHook;

    return (
        <GridRow>
            <GridItem className={"col-xs-12-4"}>
                <Select
                    label={"Area pubblica"}
                    options={[
                        { label: "Tutti", value: "" },
                        { label: "Visibile", value: true },
                        { label: "Non visibile", value: false },
                    ]}
                    setValue={setValue}
                    value={form.enabled}
                    path={"enabled"}
                    showPlaceholder
                    filterInput
                />
            </GridItem>
        </GridRow>
    );
}

function WorkOffersTableFilters({
    workOffersListHook,
}: {
    workOffersListHook: WorkOffersListHook;
}) {
    const { onSearchFilterChange, filterSearchHook, staticFilterHook } = workOffersListHook;

    const { applyFilters, clearFilters, form } = filterSearchHook;

    const { clearStaticFilters } = staticFilterHook;

    const clearAllFilters = React.useCallback(() => {
        clearFilters();
        clearStaticFilters();
    }, [clearStaticFilters, clearFilters]);

    return (
        <FiltersContainer
            applyFilters={applyFilters}
            clearFilters={clearAllFilters}
            extraFilters={<WorkOffersExtraFilters workOffersListHook={workOffersListHook} />}
            openDefault={staticFilterHook.filters.length > 0}
        >
            <GridItem className={"col-xs-12-4"}>
                <SearchInput
                    placeholder={"Cerca"}
                    value={form.search.title}
                    onChange={onSearchFilterChange}
                    filterInput
                />
            </GridItem>
        </FiltersContainer>
    );
}

export default WorkOffersTableFilters;
